import { useMediaQuery } from "./breakpoint";

export function usePrefersReducedMotion() {
	return useMediaQuery('(prefers-reduced-motion: reduce)');
}